const log = (params) => {
  const $metaTag = document.querySelector("meta[name='env']");

  if($metaTag && $metaTag.content !== "production") {
    console.log(params);
  }
};

export default log;
